import Typography from '@mui/material/Typography';

const Text = ({ children, ...props }) => (
  <Typography variant="body1" color="text.secondary" {...props}>
    {children}
  </Typography>
);

export default Text;

